"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeReplier = void 0;
var framebus_1 = require("../framebus");
var uuid_1 = __importDefault(require("@braintree/uuid"));
function subscribeReplier(fn, origin) {
  var uuid = (0, uuid_1.default)();
  function replier(data, replyOriginHandler) {
    fn(data, replyOriginHandler);
    framebus_1.Framebus.target({
      origin: origin
    }).off(uuid, replier);
  }
  framebus_1.Framebus.target({
    origin: origin
  }).on(uuid, replier);
  return uuid;
}
exports.subscribeReplier = subscribeReplier;